// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d986d501","453":"f26b1232","640":"eeb3766e"}[chunkId] + ".chunk.js";
};